let memoryToken = null;

// ✅ Store token in memory
export const setMemoryToken = (token) => {
  localStorage.setItem("accessToken", token);
};

// ✅ Get token from memory
export const getMemoryToken = () => {
  return localStorage.getItem("accessToken");
};

// ✅ Clear token from memory (used when token expires or user logs out)
export const clearMemoryToken = () => {
  localStorage.removeItem("accessToken");
};
